import { formatearMontoGasto } from '../../utils/gastos'

function Fila({ etiqueta, valor, destacado = false }) {
  return (
    <div>
      <p className="text-xs text-slate-500">{etiqueta}</p>

      <p
        className={
          destacado
            ? 'text-xl font-bold text-slate-900'
            : 'text-lg font-bold text-slate-700'
        }
      >
        {valor}
      </p>
    </div>
  )
}

function CobrosPagos({
  cobradoPos,
  cobradoOtrosIngresos,
  porCobrarPos,
  pagadoMes,
  pendientePorPagar,
}) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
      <h3 className="text-lg font-bold text-slate-900">
        Cobros y pagos
      </h3>

      <p className="mt-1 text-sm text-slate-500">
        Resumen del período seleccionado.
      </p>

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="space-y-4 rounded-xl bg-emerald-50 p-5">
          <p className="text-sm font-semibold text-emerald-700">
            Cobros
          </p>

          <Fila
            etiqueta="Cobrado POS"
            valor={formatearMontoGasto(cobradoPos)}
            destacado
          />

          <Fila
            etiqueta="Cobrado otros ingresos"
            valor={formatearMontoGasto(cobradoOtrosIngresos)}
          />

          <Fila
            etiqueta="Por cobrar POS"
            valor={formatearMontoGasto(porCobrarPos)}
          />
        </div>

        <div className="space-y-4 rounded-xl bg-slate-50 p-5">
          <p className="text-sm font-semibold text-slate-700">
            Pagos
          </p>

          <Fila
            etiqueta="Pagado este período"
            valor={formatearMontoGasto(pagadoMes)}
            destacado
          />

          <Fila
            etiqueta="Pendiente por pagar"
            valor={formatearMontoGasto(pendientePorPagar)}
          />
        </div>
      </div>
    </div>
  )
}

export default CobrosPagos
